(function ($) {

    $.fn.camcomWooCommerce = function () {

        const init = function () {

            $('.slider-gallery__content').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: '.slider-gallery__navigation',
                arrows: false,
                dots: false,
                adaptiveHeight: false,
                infinite: false
            });


            $('.slider-gallery__navigation').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '.slider-gallery__content',
                dots: false,
                arrows: false,
                adaptiveHeight: false,
                centerMode: true,
                //centerPadding: '100px',
                focusOnSelect: true

            });

            camcomLightbox('.slider-gallery', '.slider-gallery__content .slick-slide');

            $('.single-product-variation-radio-wrapper').find('input[checked="checked"]').parent().addClass('is-active');

            $('.variation-radio-label').on('click', function (event) {

                $('.variation-radio-label').removeClass('is-active');
                $(this).addClass('is-active');

            });

            $(document).on('show_variation', 'single_variation_wrap', (e) => {

                let hasText = !!$.trim($('.woocommerce-variation.single_variation').text());

                $('.woocommerce-variation.single_variation').stop().removeAttr('style').toggle(hasText);

            }).on('hide_variation', (e) => {

                $('.woocommerce-variation.single_variation').stop().hide();

            });

            $('.cart').on('click', '.ajax_add_to_cart', function () {

                $(this).html('Adding...');

            });

            $('.atc').on('click', '.atc__quantity__button', function (event) {

                event.preventDefault();

                var elem = $(this),
                    increment = elem.data('increment'),
                    input = elem.parent().find('input[type="number"]'),
                    inputMin = input.attr('min'),
                    inputMax = input.attr('max'),
                    inputValue = parseInt(input.val()),
                    newInputValue;

                if (!inputMax) {

                    inputMax = 100;

                }


                switch (increment) {

                    case 'plus':

                        if (inputValue < inputMax) {

                            newInputValue = inputValue + 1;

                            input.val(newInputValue);

                            if (newInputValue == inputMax) {

                                elem.attr('disabled', 'disabled');
                                elem.siblings(elem).removeAttr('disabled');

                            } else {

                                elem.siblings(elem).removeAttr('disabled');

                            }

                        }

                        break;

                    case 'minus':

                        if (inputValue > inputMin) {

                            newInputValue = inputValue - 1;

                            input.val(newInputValue);

                            if (newInputValue == inputMin) {

                                elem.attr('disabled', 'disabled');
                                elem.siblings(elem).removeAttr('disabled');

                            } else {

                                elem.siblings(elem).removeAttr('disabled');

                            }

                        }

                        break;

                }

                $('.woocommerce-cart-form').find('button[name="update_cart"]').prop('disabled', false).attr('aria-disabled', false).trigger('click');

            });

            $('.atc').on('change', '.atc__quantity__input', function (event) {

                event.preventDefault();

                $('.woocommerce-cart-form').find('button[name="update_cart"]').prop('disabled', false).attr('aria-disabled', false).trigger('click');

            });


            $('.atc__submit:not(.atc__submit--composite)').on('click', function (event) {

                event.preventDefault();

                var elem = $(this),
                    quantity = 1,
                    buttonText = elem.text(),
                    productId, bundledProductIds = [],
                    variationId;

                if (elem.hasClass('atc__submit--variation') && $('input[name="variation_id"]').val() < 1) {

                    return;

                }

                if ($('.bundle_sells_form').length) {

                    $('.bundle_sells_form .cart').each(function (index, elem) {

                        bundledProductIds.push($(elem).data('product_id'));

                    });

                }

                if (elem.is('a')) {

                    productId = elem.data('product_id');

                } else {

                    if (elem.hasClass('atc__submit--variation')) {

                        productId = $('input[name="product_id"]').val();
                        variationId = $('input[name="variation_id"]').val();

                    } else {

                        productId = elem.val();

                    }

                    quantity = elem.parents('.atc').find('.atc__quantity__input').val();

                }

                if (productId) {

                    $.ajax({
                        url: ajax_variables.ajax_url,
                        method: 'POST',
                        data: {
                            'action': 'camcom_add_to_cart',
                            'product_id': productId,
                            'bundled_product_ids': bundledProductIds,
                            'variation_id': variationId,
                            'quantity': quantity
                        },
                        beforeSend: function () {
                            elem.text('Adding...');
                        },
                        success: function (data) {

                            $('.camcom').after(data).promise().done(function () {

                                var cartModal = $('body').modal();

                                $('.site-head__actions__basket__count').text(parseInt($('.site-head__actions__basket__count').text()) + 1);

                                cartModal.modalOpen($('#modal_cart'));

                                elem.text(buttonText);

                            });

                        }

                    });

                }

            });

            /** Composite Product — Live Price Update */
            $('.component_options_select').on('change', function () {

                var compositeData = $('.composite_data').data('price_data'),
                    totalPrice = compositeData.base_price;

                $('.component_options').each(function () {

                    var $comp = $(this),
                        componentOptions = $comp.data('options_data'),
                        $componentSelect = $comp.find('.component_options_select'),
                        selectedProduct = $componentSelect.val(),
                        componentId = $componentSelect.data('component_id');

                    if (!selectedProduct) { return; }

                    // Multiply by the component quantity (e.g. 2 for double-bladed sabers) — otherwise the
                    // preview undercounts blades and disagrees with the cart total the server actually bills.
                    var componentQty = compositeData.quantities && compositeData.quantities[componentId] || 1;

                    $.each(componentOptions, function (index, component) {

                        if (component.option_id == selectedProduct) {
                            totalPrice += component.option_product_data.price * componentQty;
                            return false;
                        }

                    });

                });

                var displayPrice = (Math.ceil(totalPrice) - 0.01).toFixed(2);

                $('.atc__price--composite').each(function () {

                    var text = $(this).text().replace(/^From:\s*/i, ''),
                        newText = text.replace(/[\d,]+\.?\d*/, displayPrice);

                    $(this).text(newText);

                });

            });

            $('.atc__submit--composite').on('click', function (event) {

                event.preventDefault();

                if($(this).hasClass('disabled')){

                    return;

                }

                var elem = $(this),
                    buttonText = elem.text(),
                    productElem = $('.composite_data'),
                    productId = productElem.data('container_id');

                var componentsElem = $('.component_options'),
                    componentConfig = {},
                    ajaxAction = 'camcom_add_composite_to_cart';

                componentsElem.find('select').each(function (index, elem) {

                    var componentId = $(elem).data('component_id'),
                        componentProduct = $(elem).val();

                    if (componentProduct) {

                        componentConfig[componentId] = {product_id: componentProduct};

                    }

                });

                if (Object.keys(componentConfig).length === 0) {

                    ajaxAction = 'camcom_add_to_cart';

                }

                $.ajax({
                    url: ajax_variables.ajax_url,
                    type: 'POST',
                    data: {
                        'action': ajaxAction,
                        'product_id': productId,
                        'component_config': componentConfig,
                        // Scope to the composite's main qty input (name="quantity").
                        // The theme adds `atc__quantity__input` to every WC qty input
                        // via woocommerce_quantity_input_classes — so on double-bladed
                        // sabers the plain selector picks up the hidden blade
                        // component qty (2) instead of the composite qty (1),
                        // ending in 2 hilts + 4 blades in the cart.
                        'quantity': productElem.find('input[name="quantity"]').val()
                    },
                    beforeSend: function () {
                        elem.text('Adding...');
                    },
                    success: function (data) {

                        $('.camcom').after(data).promise().done(function () {

                            var cartModal = $('body').modal();

                            $('.site-head__actions__basket__count').text(parseInt($('.site-head__actions__basket__count').text()) + 1);

                            cartModal.modalOpen($('#modal_cart'));

                            elem.text(buttonText);

                        });

                    }

                });

            })

        };

        $('.atc__submit--gift').on('click', function (event) {

            event.preventDefault();

            var elem = $(this),
                productId = elem.data('product_id'),
                componentConfig = {},
                componentId = elem.data('component_id'),
                componentProduct = elem.data('component_product_id');

            componentConfig[componentId] = {product_id: componentProduct};

            $.ajax({
                url: ajax_variables.ajax_url,
                type: 'POST',
                data: {
                    'action': 'camcom_add_gift_to_cart',
                    'nonce': ajax_variables.gift_nonce,
                    'product_id': productId,
                    'component_config': componentConfig,
                    'quantity': 1
                },
                beforeSend: function () {
                    $('.cart-gift__overlay').removeClass('is-hidden').addClass('is-active');

                    $('html, body').animate({
                        scrollTop: $('#add-gift-to-cart-message').offset().top - 100
                    })

                },
                success: function (data) {

                    $('.cart-gift__overlay').addClass('is-hidden').removeClass('is-active');

                    location.reload(true);

                }

            });


        });

        /*$('.order-account form').on('submit', function (event) {

            event.preventDefault();

            $('#ugp_set_password').trigger('click');

        });*/

        $('#camcom_set_password').on('click', function (event) {

            event.preventDefault();

            var form = $(this).parents('.form'),
                userLogin = form.find('#camcom_customer_email'),
                formSubmit = $(this);

            formSubmit.val('Sending...');

            $.ajax({
                url: ajax_variables.ajax_url,
                method: 'POST',
                data: {
                    'action': 'camcom_trigger_password_reset_email',
                    'email': userLogin.val()
                },
                success: function (data) {

                    formSubmit.val('Reset Password').blur();

                }

            });

        });
        /*
                $('button[name="apply_coupon"]').on('click', function (event) {

                    console.log('Apply Voucher');

                });*/

        init();

        return this;

    }

}(jQuery));